import {
  IonButton,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
//import {Gait} from './../../vision-algo/gait';

interface Props {
  setPaperPlacement: Function;
  exitModalText: String;
}
const PaperPlacementModal: React.FC<Props> = ({ setPaperPlacement, exitModalText }) => {
  let history = useHistory();
  const ExitModal = () => {
    //      Gait.current_state = this.states[0];
    setPaperPlacement(false);
     history.push("/patient-page");
  };
  return (
    <>
      <div className="paper-placement-wrapper">
        <h1 className="ion-text-center">
          {exitModalText} Assessment Setup
        </h1>
        <p>Are you sure you want to exit? </p>
        <p>You will be taken back to the patient profile.</p>
        <div className="btn-wrap-sec two-btns gait-assment-btn">
          <IonButton className="cancel-btn" onClick={() => setPaperPlacement(false)} placeholder={undefined}>Cancel</IonButton>
          <IonButton className="generic-btn" onClick={() => { ExitModal(); } } placeholder={undefined}>Yes, Exit Setup</IonButton>
        </div>
      </div>
    </>
  );
};

export default PaperPlacementModal;
